import { render, staticRenderFns } from "./BalancesLoader.vue?vue&type=template&id=abfcd464&scoped=true"
import script from "./BalancesLoader.vue?vue&type=script&lang=ts"
export * from "./BalancesLoader.vue?vue&type=script&lang=ts"
import style0 from "./BalancesLoader.vue?vue&type=style&index=0&id=abfcd464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfcd464",
  null
  
)

export default component.exports